import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Image from 'global/Image';
import { ButtonTransparent } from 'global/MainLayout/SideWidget/styled';
import If from 'global/ErrorHandlers/If';
import { selectors } from 'lib/entities/profile';
import { useSelector } from 'react-redux';
import { Community, Fee } from '../../../../@types/community';
import { DetailContainer, Next } from '../styled';
import Fieldset from './Fieldset';
import Info from './Info';
import { useShareReceipt } from '../hooks/useShareReceipt';

interface Props {
  fee: Fee;
  until: string;
  onLeave: (e: React.MouseEvent<HTMLButtonElement>) => void;
  community: Community;
  ableToLeave: boolean;
}

function Detail({ fee, until, onLeave, community, ableToLeave }: Props) {
  const {
    data: { phone, username },
  } = useSelector(selectors);

  const showModal = useShareReceipt((store) => store.showShareModal);

  const handleShareClick = () => {
    showModal(community.leader.username, community.name, username, phone);
  };

  return (
    <div style={{ width: '400px', margin: 'auto' }}>
      <DetailContainer align="center" justify="flex-start">
        <Image
          alt="logo"
          src="images/community/active-hero.svg"
          width={180}
          height={140}
        />
        <Fieldset fee={fee} community={community} withProfile />
        <If condition={!ableToLeave}>
          <Info until={until} />
          {/* @ts-expect-error */}
          <Flex mt="16px" width="100%">
            <Next width="100%" onClick={handleShareClick}>
              Bagikan Bukti Aktivasi
            </Next>
          </Flex>
        </If>
        <If condition={ableToLeave}>
          <ButtonTransparent onClick={onLeave}>
            <Text
              family="bold"
              color="rgba(238, 74, 73, 1)"
              size="14px"
              height="19px"
              align="center"
              // @ts-expect-error
              mt="16px"
              p="12px"
            >
              Keluar Komunitas
            </Text>
          </ButtonTransparent>
        </If>
      </DetailContainer>
    </div>
  );
}

export default Detail;
